const initialState = [];

const messagesReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_MESSAGES":
      return action.data;
    default:
      return state;
  }
};

export default messagesReducer;
